import { collection, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

const getAll = async (account: string, menu: string) => {
  const snapshot = await getDocs(collection(db, `menus/${account}/menu/${menu}/products`));
  let products = snapshot.docs.map((doc) => ({ id: doc.id, name: '', categoryId: '', order: 0, price: 0, active: false, ...doc.data() }));
  products = products as any;
  return products.filter(it => it.active === true).sort((oldRelease: any, newRelease: any) => {
    const comparecategoryId = `${oldRelease.categoryId}`.localeCompare(`${newRelease.categoryId}`);
    const compareOrder = `${oldRelease.order}`.localeCompare(`${newRelease.order}`);
    const compareName = oldRelease.name.localeCompare(newRelease.name);
    return comparecategoryId || compareOrder || compareName;
  });
};

const funcs = {
  getAll,
};

export default funcs;
